module.exports = __webpack_public_path__ + "dashboard/img/check-12.8f2eeb7b221674fad895975afc6a3652.svg";